import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import './Paragraph.styles.js';
import { fComp } from '../../utils/React.js';

var defaultProps = {
  size: "copy-text",
  centeredLayout: false,
  htmlAttrs: {},
  disabled: false
};
var ParagraphPresentation = fComp(function (_ref) {
  var _cleanupClassObject;
  var as = _ref.as,
    children = _ref.children,
    id = _ref.id,
    className = _ref.className,
    noMargin = _ref.noMargin,
    size = _ref.size,
    centeredLayout = _ref.centeredLayout,
    horizontalAlignment = _ref.horizontalAlignment,
    disabled = _ref.disabled,
    htmlAttrs = _ref.htmlAttrs,
    manualHyphenation = _ref.manualHyphenation;
  var As = as || "p";
  var align = centeredLayout ? "center" : horizontalAlignment;
  return /*#__PURE__*/React.createElement(As, Object.assign({
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, "".concat(className), !!className), _defineProperty(_cleanupClassObject, "".concat(lsgPre).concat(size), true), _defineProperty(_cleanupClassObject, "".concat(lsgPre).concat(size, "__align-").concat(align), align), _defineProperty(_cleanupClassObject, "".concat(lsgPre).concat(size, "__disabled"), disabled), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "-centered-layout"), centeredLayout), _defineProperty(_cleanupClassObject, "".concat(lsgPre).concat(size, "__hyphens-manual"), manualHyphenation), _cleanupClassObject)),
    "aria-atomic": ["helper-text", "error-text"].includes(size) ? true : undefined
  }, htmlAttrs), children);
}, defaultProps);
ParagraphPresentation.displayName = "ParagraphPresentation";

export { ParagraphPresentation };
